import { FC, ReactNode } from 'react';
import style from './index.module.css';

export const Description: FC<{ 
  disabledMargin?: boolean
  children: ReactNode
}> = ({ children, disabledMargin = false }) => {

  const className = `${style.description} ${disabledMargin ? style.disabledMargin : '' }`;

  return (
    <p className={ className }>
      { children }
    </p>
  )
}